<template>
  <div class="l_page">
    <div class="pickers">
      <div class="pick_box">
        <select>
          <option value="">合作志平的群</option>
          <option value="">合作志平个人</option>
        </select>
        <span class="icon-arrow_btm icon_btm"></span>
      </div>
      <p>(等级：6级 分成比例：55%)</p>
    </div>
    <div class="list_wrapper">
      <div class="countList">
     <div class="countTitle countItem">全部：</div>
     <div class="countItem">
       <div  class="countTitle">有效/订单数</div>
       <div class="countCtent">10/10</div>
     </div>
     <div class="countItem">
       <div  class="countTitle">效果预估</div>
       <div class="countCtent">0.00</div>
     </div>
     <div class="countItem">
       <div class="countTitle">预估收入</div>
       <div class="countCtent">0.00</div>
     </div>
     <div class="countItem">
       <div class="countTitle">券币/次数</div>
       <div class="countCtent">10/20</div>
     </div>
     <div class="countItem">
       <div class="countTitle">新用户</div>
       <div class="countCtent">20</div>
     </div>
 </div>
 <div class="countList">
<div class="countTitle countItem">上月：</div>
<div class="countItem">
  <div  class="countTitle">有效/订单数</div>
  <div class="countCtent">10/10</div>
</div>
<div class="countItem">
  <div  class="countTitle">效果预估</div>
  <div class="countCtent">0.00</div>
</div>
<div class="countItem">
  <div class="countTitle">预估收入</div>
  <div class="countCtent">0.00</div>
</div>
<div class="countItem">
  <div class="countTitle">券币/次数</div>
  <div class="countCtent">10/20</div>
</div>
<div class="countItem">
  <div class="countTitle">新用户</div>
  <div class="countCtent">20</div>
</div>
</div>
<div class="countList">
<div class="countTitle countItem">本月：</div>
<div class="countItem">
 <div  class="countTitle">有效/订单数</div>
 <div class="countCtent">10/10</div>
</div>
<div class="countItem">
 <div  class="countTitle">效果预估</div>
 <div class="countCtent">0.00</div>
</div>
<div class="countItem">
 <div class="countTitle">预估收入</div>
 <div class="countCtent">0.00</div>
</div>
<div class="countItem">
 <div class="countTitle">券币/次数</div>
 <div class="countCtent">10/20</div>
</div>
<div class="countItem">
 <div class="countTitle">新用户</div>
 <div class="countCtent">20</div>
</div>
</div>
<div class="countList">
<div class="countTitle countItem">上周：</div>
<div class="countItem">
 <div  class="countTitle">有效/订单数</div>
 <div class="countCtent">10/10</div>
</div>
<div class="countItem">
 <div  class="countTitle">效果预估</div>
 <div class="countCtent">0.00</div>
</div>
<div class="countItem">
 <div class="countTitle">预估收入</div>
 <div class="countCtent">0.00</div>
</div>
<div class="countItem">
 <div class="countTitle">券币/次数</div>
 <div class="countCtent">10/20</div>
</div>
<div class="countItem">
 <div class="countTitle">新用户</div>
 <div class="countCtent">20</div>
</div>
</div>
<div class="countList">
<div class="countTitle countItem">本周：</div>
<div class="countItem">
 <div  class="countTitle">有效/订单数</div>
 <div class="countCtent">10/10</div>
</div>
<div class="countItem">
 <div  class="countTitle">效果预估</div>
 <div class="countCtent">0.00</div>
</div>
<div class="countItem">
 <div class="countTitle">预估收入</div>
 <div class="countCtent">0.00</div>
</div>
<div class="countItem">
 <div class="countTitle">券币/次数</div>
 <div class="countCtent">10/20</div>
</div>
<div class="countItem">
 <div class="countTitle">新用户</div>
 <div class="countCtent">20</div>
</div>
</div>
<div class="countList">
<div class="countTitle countItem">昨天：</div>
<div class="countItem">
 <div  class="countTitle">有效/订单数</div>
 <div class="countCtent">10/10</div>
</div>
<div class="countItem">
 <div  class="countTitle">效果预估</div>
 <div class="countCtent">0.00</div>
</div>
<div class="countItem">
 <div class="countTitle">预估收入</div>
 <div class="countCtent">0.00</div>
</div>
<div class="countItem">
 <div class="countTitle">券币/次数</div>
 <div class="countCtent">10/20</div>
</div>
<div class="countItem">
 <div class="countTitle">新用户</div>
 <div class="countCtent">20</div>
</div>
</div>
<div class="countList">
<div class="countTitle countItem">今天：</div>
<div class="countItem">
 <div  class="countTitle">有效/订单数</div>
 <div class="countCtent">10/10</div>
</div>
<div class="countItem">
 <div  class="countTitle">效果预估</div>
 <div class="countCtent">0.00</div>
</div>
<div class="countItem">
 <div class="countTitle">预估收入</div>
 <div class="countCtent">0.00</div>
</div>
<div class="countItem">
 <div class="countTitle">券币/次数</div>
 <div class="countCtent">10/20</div>
</div>
<div class="countItem">
 <div class="countTitle">新用户</div>
 <div class="countCtent">20</div>
</div>
</div>
    </div>

  </div>
</template>

<script>
export default {
  name:"myOrderList"
}
</script>

<style lang="stylus">
  .l_page
    padding:30px 15px
    background:#fff
    .pickers
      display:flex
      align-items:center
      font-size:25px
      color:#333
      line-height:45px
      .pick_box
        position:relative
        margin-right:10px
        .icon_btm
          position:absolute
          right:0px
          top:10px
    .list_wrapper
      width: 93%
      margin-left: 10px
      display: flex
      flex-direction: column
      justify-content: space-around
      font-size: 25px
      padding: 15px
      border: 1px solid #eee
      /*px*/
      border-radius: 15px
      margin-top:15px
      .countList
        margin-top: 15px
        display: flex
        flex-direction: row
        justify-content: space-around
        align-items: center
        padding-bottom: 15px
        border-bottom: 1px solid #eee

</style>



// WEBPACK FOOTER //
// src/components/userCenter/myOrderList.vue